import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { AISuggestionNode, GeneratePrompt } from 'types'
import { buildErrorMessage } from 'utils'
import { reportError } from 'utils/error'
import { UseMutationOptions } from 'react-query/types/react/types'

interface Variables {
  prompt: GeneratePrompt
}

interface Props {
  articleId: string
  layerId: string
  id: string
}

type Data = { node: AISuggestionNode }

export type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

export const updateAISuggestionNode = async ({ articleId, layerId, id, prompt }: Props & Variables) => {
  const response = await sendToApi<Data>(`/articles/${articleId}/layers/${layerId}/ai_suggestion_nodes/${id}`, {
    method: 'PATCH',
    body: {
      prompt,
    },
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    reportError('Failed to update ai suggestion node', {
      metaData: {
        id,
        response: response.data,
      },
    })
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }

  return response.data
}

export const useUpdateAISuggestionNode = ({ articleId, layerId, id }: Props, options?: Options) => {
  return useMutation<Data, unknown, Variables>(
    ['articles', articleId, 'layers', layerId, 'aiSuggestionNodes', id],
    (variables) => {
      return updateAISuggestionNode({ articleId, layerId, id, ...variables })
    },
    {
      ...options,
    },
  )
}
